import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.ContactInfo.title',
    defaultMessage: 'Get a free custom demo',
  },
  description: {
    id: 'components.ContactInfo.description',
    defaultMessage:
      "In doubt about the right voice? Don’t worry - with a free reading sample from your favorite artists, you can hear their voices on your script to find the perfect match and avoid miscasting.",
  },
  free: {
    id: 'components.ContactInfo.description.free',
    defaultMessage: 'free of charge',
  },
  write: {
    id: 'components.ContactInfo.write',
    defaultMessage: '-',
  },
  call: {
    id: 'components.ContactInfo.call',
    defaultMessage: 'Call {name} at {phone}',
  },
  imageURL: {
    id: 'components.ContactInfo.imageURL',
    defaultMessage:
      'https://voicefinder-assets.s3.eu-north-1.amazonaws.com/contact-widget/en-gb.jpg',
  },
  name: {
    id: 'components.ContactInfo.name',
    defaultMessage: 'Anna Sticken',
  },
  shortName: {
    id: 'components.ContactInfo.shortName',
    defaultMessage: 'Anna',
  },
  phone: {
    id: 'components.ContactInfo.phone',
    defaultMessage: '+44 (0) 20 7993 8251',
  },
  email: {
    id: 'components.ContactInfo.email',
    defaultMessage: 'anna@voicearchive.com',
  },
  contact: {
    id: 'components.ContactInfo.contact',
    defaultMessage: 'Get in touch',
  },
  avatarUrl: {
    id: 'components.ContactInfo.avatarUrl',
    defaultMessage: 'https://voicearchive-employees.s3.eu-central-1.amazonaws.com/anna.jpg',
  },



  titleContactHelpCard: {
    id: 'components.ContactInfo.ContactHelpCard.titleContactHelpCard',
    defaultMessage: 'Can’t find the right voice — or running out of time?',
  },
  descriptionContactHelpCard: {
    id: 'components.ContactInfo.ContactHelpCard.descriptionContactHelpCard',
    defaultMessage:
      "Let us do the scouting for you, free of charge. With a clear creative brief, our experts instantly know which artists fit your vision — saving you time and guesswork.",
  },
  shortNameContactHelpCard: {
    id: 'components.ContactInfo.ContactHelpCard.shortNameContactHelpCard',
    defaultMessage: 'Anna',
  },
  emailContactHelpCard: {
    id: 'components.ContactInfo.ContactHelpCard.emailContactHelpCard',
    defaultMessage: 'anna@voicearchive.com',
  },
  contactContactHelpCard: {
    id: 'components.ContactInfo.ContactHelpCard.contactContactHelpCard',
    defaultMessage: 'Get in touch',
  },
})
